module.exports = __webpack_public_path__ + "static/media/ImporterFeatureIcon4.561078fe.svg";